<template>
  <ContentWrap>
    <!-- 搜索工作栏 -->
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="84px"
    >
      <el-form-item label="公司名称" prop="name">
        <el-input
          v-model="queryParams.name"
          class="!w-240px"
          clearable
          placeholder="请输入公司名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="主要联系人" prop="contactName">
        <el-input
          v-model="queryParams.contactName"
          class="!w-240px"
          clearable
          placeholder="请输入主要联系人"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="联系手机" prop="mobile">
        <el-input
          v-model="queryParams.mobile"
          class="!w-240px"
          clearable
          placeholder="请输入联系手机"
          @keyup.enter="handleQuery"
          @input="(v: string) => (queryParams.mobile = onlyDigits(v))"
        />
      </el-form-item>
      <el-form-item label="需求分类" prop="requirementCategoryId">
        <el-select
          v-model="queryParams.requirementCategoryId"
          class="!w-240px"
          clearable
          placeholder="请选择需求分类"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_REQUIREMENT_CATEGORY)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="客户状态" prop="customerStatus">
        <el-select
          v-model="queryParams.customerStatus"
          class="!w-240px"
          clearable
          placeholder="请选择客户状态"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.CRM_CUSTOMER_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <!-- 全部客户不提供新增 -->
        <el-button
          v-if="showCreate"
          v-hasPermi="['crm:customer:create']"
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 列表 -->
  <ContentWrap>
    <el-tabs v-if="showTabs" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="我负责的" name="1" />
      <el-tab-pane label="我参与的" name="2" />
      <el-tab-pane label="下属负责的" name="3" />
      <el-tab-pane label="我共享的" name="4" />
      <el-tab-pane label="别人共享给我的" name="5" />
    </el-tabs>

    <!-- 批量操作栏 -->
    <div class="mb-10px">
      <el-button
        v-if="isOwnerTab"
        v-hasPermi="['crm:customer:update']"
        :disabled="selectedIds.length === 0"
        type="primary"
        plain
        @click="handlePutPool(selectedIds)"
      >
        <Icon class="mr-5px" icon="ep:bottom" />
        转为公海
      </el-button>
      <el-button
        v-if="isOwnerTab"
        v-hasPermi="['crm:customer:share']"
        :disabled="selectedIds.length === 0"
        type="success"
        plain
        @click="openShareDialog('share', selectedIds)"
      >
        <Icon class="mr-5px" icon="ep:share" />
        共享客户
      </el-button>
      <el-button
        v-if="isOwnerTab"
        v-hasPermi="['crm:customer:update']"
        :disabled="selectedIds.length === 0"
        type="warning"
        plain
        @click="handleSetStarred(selectedIds, true)"
      >
        <Icon class="mr-5px" icon="ep:star-filled" />
        标星
      </el-button>
      <el-button
        v-if="isOwnerTab"
        v-hasPermi="['crm:customer:update']"
        :disabled="selectedIds.length === 0"
        plain
        @click="handleSetStarred(selectedIds, false)"
      >
        <Icon class="mr-5px" icon="ep:star" />
        取消标星
      </el-button>
      <el-button
        v-if="isOwnerTab"
        v-hasPermi="['crm:customer:update']"
        :disabled="selectedIds.length === 0"
        type="danger"
        plain
        @click="handleSetTopped(selectedIds, true)"
      >
        <Icon class="mr-5px" icon="ep:top" />
        置顶
      </el-button>
      <el-button
        v-if="isOwnerTab"
        v-hasPermi="['crm:customer:update']"
        :disabled="selectedIds.length === 0"
        plain
        @click="handleSetTopped(selectedIds, false)"
      >
        <Icon class="mr-5px" icon="ep:bottom" />
        取消置顶
      </el-button>
      <el-button
        v-if="isSharedByMeTab"
        v-hasPermi="['crm:customer:unshare']"
        :disabled="selectedIds.length === 0"
        type="warning"
        plain
        @click="openShareDialog('unshare', selectedIds)"
      >
        <Icon class="mr-5px" icon="ep:close-bold" />
        取消共享
      </el-button>
      <el-button v-hasPermi="['crm:customer:import']" plain type="warning" @click="handleImport">
        <Icon class="mr-5px" icon="ep:upload" />
        导入
      </el-button>
      <el-button
        v-hasPermi="['crm:customer:export']"
        :loading="exportLoading"
        plain
        type="success"
        @click="handleExport"
      >
        <Icon class="mr-5px" icon="ep:download" />
        导出
      </el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="list"
      :show-overflow-tooltip="true"
      :stripe="true"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column align="center" fixed="left" label="公司名称" prop="name" width="200">
        <template #default="scope">
          <el-link :underline="false" type="primary" @click="openDetail(scope.row.id)">
            {{ scope.row.name }}
          </el-link>
          <!-- 状态标记：★ 标星（重点客户）/ ↑ 置顶 / ☇ 已共享 -->
          <span v-if="scope.row.starred" class="customer-flag flag-star" title="重点客户"> ★ </span>
          <span v-if="scope.row.topped" class="customer-flag flag-pin" title="已置顶"> ↑ </span>
          <span v-if="scope.row.shared" class="customer-flag flag-shared" title="已共享"> ☇ </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="主要联系人" prop="contactName" width="110" />
      <el-table-column align="center" label="联系手机" prop="mobile" width="130" />
      <el-table-column align="center" label="微信号" prop="wechat" width="140" />
      <el-table-column align="center" label="需求分类" prop="requirementCategoryId" width="130">
        <template #default="scope">
          <dict-tag
            :type="DICT_TYPE.CRM_CUSTOMER_REQUIREMENT_CATEGORY"
            :value="scope.row.requirementCategoryId"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="需求概述" prop="requirementSummary" width="200" />
      <el-table-column align="center" label="预算" prop="budget" width="130">
        <template #default="scope">{{ formatMoney(scope.row.budget) }}</template>
      </el-table-column>
      <el-table-column align="center" label="报价" prop="quotation" width="130">
        <template #default="scope">{{ formatMoney(scope.row.quotation) }}</template>
      </el-table-column>
      <el-table-column align="center" label="客户状态" prop="customerStatus" width="110">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.CRM_CUSTOMER_STATUS" :value="scope.row.customerStatus" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="所在市" prop="areaName" width="180" />
      <el-table-column align="center" label="跟进记录" prop="contactLastContent" width="200" />
      <el-table-column align="center" label="申请人" prop="creatorName" width="110" />
      <el-table-column align="center" label="申请部门" prop="creatorDeptName" width="130" />
      <el-table-column
        v-if="showOwnerColumn"
        align="center"
        label="负责人"
        prop="ownerUserName"
        width="110"
      />
      <el-table-column
        align="center"
        fixed="right"
        :show-overflow-tooltip="false"
        label="操作"
        width="200"
      >
        <template #default="scope">
          <div class="crm-customer-action">
            <el-button
              v-if="isOwnerRow(scope.row)"
              v-hasPermi="['crm:customer:update']"
              link
              type="primary"
              @click="handlePutPool([scope.row.id])"
            >
              转为公海
            </el-button>
            <el-button
              v-hasPermi="['crm:customer:update']"
              link
              type="primary"
              @click="openForm('update', scope.row.id)"
            >
              编辑
            </el-button>
            <el-dropdown trigger="click" @command="(command) => handleCommand(command, scope.row)">
              <el-button link type="primary">
                更多
                <Icon class="ml-2px" icon="ep:arrow-down" />
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="detail">详情</el-dropdown-item>
                  <el-dropdown-item v-hasPermi="['crm:follow-up-record:create']" command="followUp">
                    跟进
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="isOwnerRow(scope.row)"
                    v-hasPermi="['crm:customer:share']"
                    command="share"
                  >
                    共享
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="isOwnerRow(scope.row)"
                    v-hasPermi="['crm:customer:update']"
                    command="toggleStar"
                  >
                    {{ scope.row.starred ? '取消标星' : '标星' }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="isOwnerRow(scope.row)"
                    v-hasPermi="['crm:customer:update']"
                    command="togglePin"
                  >
                    {{ scope.row.topped ? '取消置顶' : '置顶' }}
                  </el-dropdown-item>
                  <el-dropdown-item v-if="isOwnerRow(scope.row)" command="delete">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 表单弹窗：添加/修改 -->
  <CustomerForm ref="formRef" @success="getList" />
  <CustomerImportForm ref="importFormRef" @success="getList" />
  <!-- 共享 / 取消共享 -->
  <CustomerShareDialog ref="shareDialogRef" @success="getList" />
  <!-- 添加跟进记录：复用「客户跟进」模块的表单（客户已由行上下文确定，故锁定） -->
  <FollowUpEditForm ref="followUpFormRef" lock-customer @success="getList" />
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import download from '@/utils/download'
import { onlyDigits } from '@/utils/inputFilter'
import * as CustomerApi from '@/api/crm/customer'
import CustomerForm from '../CustomerForm.vue'
import CustomerImportForm from '../CustomerImportForm.vue'
import CustomerShareDialog from './CustomerShareDialog.vue'
import FollowUpEditForm from '@/views/crm/followup/components/FollowUpEditForm.vue'
import { TabsPaneContext } from 'element-plus'
import { getCurrentUserId } from '@/utils/auth'

const props = withDefaults(
  defineProps<{
    /**
     * 公海标记：`true` 只查公海；`false` 只查非公海；`undefined` 不做限制。
     * - 我的客户：`false`（配合 sceneType 过滤，双保险，绝不出现公海数据）
     * - 全部客户：`false` + sceneType 为空 = 全量但排除公海
     */
    pool?: boolean
    /** 是否展示「我负责的 / 我参与的 / ...」5 个 tab */
    showTabs?: boolean
    /** 是否展示「新增」按钮（全部客户不提供新增，但仍可编辑） */
    showCreate?: boolean
    /** 是否展示「负责人」列 */
    showOwnerColumn?: boolean
  }>(),
  {
    pool: undefined,
    showTabs: false,
    showCreate: false,
    showOwnerColumn: true
  }
)

const message = useMessage() // 消息弹窗
const { t } = useI18n() // 国际化

const loading = ref(true) // 列表的加载中
const total = ref(0) // 列表的总页数
const list = ref<CustomerApi.CustomerVO[]>([]) // 列表的数据
const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 10,
  // ★ 必须与 activeName 的初值 '1' 保持一致。若留 undefined，qs 序列化会**丢弃该参数**，
  //   后端 sceneType=null 即「不做数据权限过滤」，会把公海客户也查出来（历史 bug）。
  sceneType: props.showTabs ? '1' : undefined,
  name: '',
  contactName: '',
  mobile: '',
  requirementCategoryId: undefined,
  customerStatus: undefined,
  // false = 只查非公海（负责人不为空）；true = 只查公海；undefined = 不做限制
  pool: props.pool
})
const queryFormRef = ref() // 搜索的表单
const exportLoading = ref(false) // 导出的加载中
const activeName = ref('1') // 列表 tab
const selectedIds = ref<number[]>([]) // 勾选的客户编号

/** 当前是否处于「我负责的」场景（支持批量转公海、共享） */
const isOwnerTab = computed(() => props.showTabs && activeName.value === '1')
/** 当前是否处于「我共享的」场景（支持批量取消共享） */
const isSharedByMeTab = computed(() => props.showTabs && activeName.value === '4')

/** 该行是否由当前用户负责（决定能否共享、转公海、删除）。用 Number 兜底，防后端把 Long 序列化成字符串 */
const isOwnerRow = (row: CustomerApi.CustomerVO) =>
  Number(row.ownerUserId) === Number(getCurrentUserId())

/** tab 切换 */
const handleTabClick = (tab: TabsPaneContext) => {
  queryParams.sceneType = tab.paneName as string
  handleQuery()
}

/** 查询列表 */
const getList = async () => {
  loading.value = true
  try {
    const data = await CustomerApi.getCustomerPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

/** 搜索按钮操作 */
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

/** 重置按钮操作 */
const resetQuery = () => {
  queryFormRef.value.resetFields()
  queryParams.name = ''
  queryParams.contactName = ''
  queryParams.mobile = ''
  queryParams.requirementCategoryId = undefined
  queryParams.customerStatus = undefined
  handleQuery()
}

/** 勾选变化 */
const handleSelectionChange = (rows: CustomerApi.CustomerVO[]) => {
  selectedIds.value = rows.map((row) => row.id)
}

/** 打开客户详情 */
const { currentRoute, push } = useRouter()
const openDetail = (id: number) => {
  push({ name: 'CrmCustomerDetail', params: { id } })
}

/** 添加/修改操作 */
const formRef = ref()
const openForm = (type: string, id?: number) => {
  formRef.value.open(type, id)
}

/** 操作列的「更多」下拉 */
const handleCommand = async (command: string, row: CustomerApi.CustomerVO) => {
  if (command === 'detail') {
    openDetail(row.id)
  } else if (command === 'followUp') {
    openFollowUpForm(row)
  } else if (command === 'share') {
    openShareDialog('share', [row.id])
  } else if (command === 'toggleStar') {
    await handleSetStarred([row.id], !row.starred)
  } else if (command === 'togglePin') {
    await handleSetTopped([row.id], !row.topped)
  } else if (command === 'delete') {
    await handleDelete(row.id)
  }
}

/** 添加跟进记录（复用「客户跟进」模块的表单，客户由行上下文带入并锁定） */
const followUpFormRef = ref<InstanceType<typeof FollowUpEditForm>>()
const openFollowUpForm = (row: CustomerApi.CustomerVO) => {
  // ★ `customerName` 必须一起传（第 4 个参数），不能只传 id：
  //   表单下拉里该客户若不在 `simple-list` 返回集合中，`el-select` 找不到 option 的 label
  //   就会把 id 直接当文案渲染出来（现象：客户框显示 `56`）。
  //   行数据里本来就有 `row.name`，传进去即可零请求解析出名称。
  followUpFormRef.value?.open('create', undefined, row.id, row.name)
}

/** 转为公海（支持批量） */
const handlePutPool = async (ids: number[]) => {
  if (!ids || ids.length === 0) {
    message.warning('请先勾选客户')
    return
  }
  try {
    await message.confirm(
      `确认将选中的 ${ids.length} 个客户转为公海吗？转入后将从「我的客户」中移除。`
    )
    await CustomerApi.putCustomerPoolBatch(ids)
    message.success(t('common.updateSuccess'))
    selectedIds.value = []
    await getList()
  } catch {}
}

/** 批量标星 / 取消标星（工具栏传 selectedIds，行菜单传单条并按当前状态取反） */
const handleSetStarred = async (ids: number[], starred: boolean) => {
  if (!ids || ids.length === 0) {
    message.warning('请先勾选客户')
    return
  }
  await CustomerApi.updateCustomerStarred(ids, starred)
  message.success(starred ? '标星成功' : '已取消标星')
  selectedIds.value = []
  await getList()
}

/** 批量置顶 / 取消置顶（工具栏传 selectedIds，行菜单传单条并按当前状态取反） */
const handleSetTopped = async (ids: number[], topped: boolean) => {
  if (!ids || ids.length === 0) {
    message.warning('请先勾选客户')
    return
  }
  await CustomerApi.updateCustomerTopped(ids, topped)
  message.success(topped ? '置顶成功' : '已取消置顶')
  selectedIds.value = []
  await getList()
}

/** 删除按钮操作 */
const handleDelete = async (id: number) => {
  try {
    // 删除的二次确认
    await message.delConfirm()
    // 发起删除
    await CustomerApi.deleteCustomer(id)
    message.success(t('common.delSuccess'))
    // 刷新列表
    await getList()
  } catch {}
}

/** 打开共享 / 取消共享弹窗 */
const shareDialogRef = ref()
const openShareDialog = (mode: 'share' | 'unshare', ids: number[]) => {
  if (!ids || ids.length === 0) {
    message.warning('请先勾选客户')
    return
  }
  shareDialogRef.value?.open(mode, ids)
}

/** 导入按钮操作 */
const importFormRef = ref<InstanceType<typeof CustomerImportForm>>()
const handleImport = () => {
  importFormRef.value?.open()
}

/** 导出按钮操作 */
const handleExport = async () => {
  try {
    // 导出的二次确认
    await message.exportConfirm()
    // 发起导出
    exportLoading.value = true
    const data = await CustomerApi.exportCustomer(queryParams)
    download.excel(data, '客户.xls')
  } catch {
  } finally {
    exportLoading.value = false
  }
}

/** 金额展示 */
const formatMoney = (value?: number) => {
  if (value === null || value === undefined) {
    return ''
  }
  return `¥ ${Number(value).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

/** 监听路由变化更新列表 */
watch(
  () => currentRoute.value,
  () => {
    getList()
  }
)

/** 初始化 **/
onMounted(() => {
  getList()
})
</script>

<style lang="scss" scoped>
/**
 * 操作列对齐：
 * element-plus 里 .el-dropdown 是 `vertical-align: top`，而 .el-button 是 `vertical-align: middle`，
 * 两者混排时「更多」会比「编辑」偏高。这里统一交给 flex 垂直居中。
 * 同时把 el-button 默认的 `margin-left: 12px` 换成 gap，避免「更多」前面缺 12px、后面又叠一层。
 */
.crm-customer-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  :deep(.el-button + .el-button) {
    margin-left: 0;
  }
}

/**
 * 公司名称后的状态标记：★ 标星（重点客户）/ ↑ 置顶 / ☇ 已共享
 * 颜色引用 Element Plus 主题变量，跟随主题
 */
.customer-flag {
  margin-left: 4px;
  font-weight: 600;
  cursor: default;

  &.flag-star {
    color: var(--el-color-warning);
  }

  &.flag-pin {
    color: var(--el-color-danger);
  }

  &.flag-shared {
    color: var(--el-color-success);
  }
}
</style>
